import * as  React from "react";
import ReactGA from "react-ga4";
import {Route} from "react-router";
import {Settings} from "./http/protocol";

interface Props {
    location : Location
}
export class Analytics extends React.Component<Props>{

    componentDidMount(): void {
        this.logPageChange(
            this.props.location.pathname,
            this.props.location.search
        );
    }
    componentDidUpdate (prevProps : Props) {
        const { location: { pathname, search } } = this.props;
        const isDifferentPathname = pathname !== prevProps.location.pathname;
        const isDifferentSearch = search !== prevProps.location.search;
        if (isDifferentPathname || isDifferentSearch) {
            this.logPageChange(pathname, search);
        }
    }
    logPageChange (pathname: string, search = '') {
        if(pathname && pathname.indexOf("resetpassword") != -1) {
            return;
        }
        const page = pathname + search;
        const { location } = window;
        ReactGA.set({
            page,
            location: `${location.origin}${page}`
        });
        ReactGA.send({ hitType : "pageview", page : page});
    }
    render() {
        return null;
    }

}

export const RouteAnalytics = () => <Route component={Analytics} />;

interface InitProps {
    ga? : string
}
export const init = (options : Settings) => {

    if (options.googleAnalyticsId) {
        ReactGA.initialize([{ trackingId : options.googleAnalyticsId}], {});
        return true;
    }

    return false;
};